import type { CreateEntryInput, Entry, UpdateEntryInput } from "shared";
import { api } from "./client";

export const entriesApi = {
	list: (layerId: string, bbox?: string) => {
		const q = bbox ? `?bbox=${encodeURIComponent(bbox)}` : "";
		return api.get<{ entries: Entry[] }>(`/layers/${layerId}/entries${q}`);
	},
	create: (layerId: string, input: CreateEntryInput) =>
		api.post<{ entry: Entry }>(`/layers/${layerId}/entries`, input),
	update: (id: string, input: UpdateEntryInput) =>
		api.patch<{ entry: Entry }>(`/entries/${id}`, input),
	remove: (id: string) => api.del<{ ok: boolean }>(`/entries/${id}`),
};
